export default "__VITE_ASSET__Bsfdp7vT__"